module.exports = __webpack_public_path__ + "static/media/108.ea58eee1.webp";